module.exports = __webpack_public_path__ + "media/images/star-sky-711d3b245321412d9d24536b6cfee293.jpg";